import { render, staticRenderFns } from "./EditKYC.vue?vue&type=template&id=191262fe&"
import script from "./EditKYC.vue?vue&type=script&lang=js&"
export * from "./EditKYC.vue?vue&type=script&lang=js&"
import style0 from "./EditKYC.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports